import { gql } from "@apollo/client";

export const GetUserConsentsQuery = gql`
  query GetUserConsents($region: AWSRegions!, $username: ID!) {
    getUser(region: $region, username: $username) {
      email
      status
      consents {
        accepted
        createdAt
        updatedAt
        name
      }
    }
  }
`;
